import { graphql } from "gql.tada";

export const LinkFragment = graphql(`
  fragment LinkFragment on Link {
    text
    isExternal
    url
    pageReference: reference {
      __typename
      ... on Page {
        slug
      }
      ... on ArticlePage {
        slug
      }
    }
  }
`);